import { get } from 'lodash';

export type StatByDocumentType = ReturnType<typeof StatByDocumentMap>;

export function StatByDocumentMap(data?: any) {
  return {
    countActive: get(data, 'countActive') || 0,
    countExpired: get(data, 'countExpired') || 0,
    countRejected: get(data, 'countRejected') || 0,
    countPaused: get(data, 'countPaused') || 0,
    countFinished: get(data, 'countFinished') || 0
  };
}

export type DocumentType = ReturnType<typeof DocumentTypeMap>;

export function DocumentTypeMap(data?: any) {
  return {
    key: get(data, 'key') || '',
    title: {
      uz: get(data, 'title.uz') || '',
      ru: get(data, 'title.ru') || '',
      en: get(data, 'title.en') || '',
      oz: get(data, 'title.oz') || ''
    }
  };
}

export type StatByDocumentsType = ReturnType<typeof StatByDocument>;

export const StatByDocument = (data?: any[]) => {
  return {
    type: get(data, 'type') || '',
    total: get(data, 'all_count') || 0,
    statuses:
      get(data, 'statuses', [])?.map(item => ({
        status: get(item, 'status') || '',
        count: get(item, 'count') || 0
      })) || []
  };
};
